import React, { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'

const ClinicInfo = ({ info, cx, cy, opacity }) => {
    const [height, setHeight] = useState(0)
    const ref = useRef(null)
    const { currentClinic } = useSelector((state) => state.clinics)

    useEffect(() => {
        if (ref.current) {
            setHeight(ref.current.getBoundingClientRect().height)
        }
    }, [ref.current])

    const handleClick = (event) => {
        // Prevent click events from bubbling up to parent elements
        event.stopPropagation()
    }

    return (
        <foreignObject
            x={cx - 130}
            y={cy - height - 47}
            width='260'
            height={height + 43}
        >
            <div
                style={{
                    alignContent: 'flex-end',
                    // height: height + 20,
                    height: currentClinic ? height + 20 : height + 42,
                    padding: '10px',
                    flexDirection: 'column',
                    fontFamily: 'sans-serif',
                    opacity,
                    cursor: 'default',
                }}
                onClick={handleClick}
            >
                <div
                    ref={ref}
                    style={{
                        pointerEvents: 'auto', // Allow interactions
                        background: `#FFFFFF 0% 0% no-repeat padding-box`,
                        boxShadow: `0px 0px 10px #0000001A`,
                        borderRadius: `5px`,
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }}
                >
                    {info.thumbnail && (
                        <img
                            src={info.thumbnail}
                            alt={info.title}
                            style={{
                                width: '100%',
                                height: 110,
                            }}
                        />
                    )}
                    <div
                        style={{
                            padding: 5,
                            paddingTop: 0,
                        }}
                    >
                        <a
                            href={info.permalink}
                            style={{
                                fontWeight: 700,
                                fontSize: 14,
                                letterSpacing: '0px',
                                color: '#4273AD',
                                textTransform: 'uppercase',
                                textDecoration: 'none',
                                cursor: 'pointer',
                            }}
                        >
                            {info.title}
                        </a>
                        <p
                            style={{
                                textAlign: 'left',
                                fontWeight: 400,
                                fontSize: 12,
                                letterSpacing: '0px',
                                color: '#55555A',
                                marginTop: 5,
                                marginBottom: 5,
                                lineHeight: '16px',
                            }}
                        >
                            {info.excerpt}
                        </p>
                        <a
                            href={info.permalink}
                            style={{
                                font: 'normal normal 800 14px',
                                letterSpacing: '0px',
                                color: '#4273AD',
                                textDecoration: 'none',
                                textTransform: 'uppercase',
                                cursor: 'pointer',
                            }}
                        >
                            {`>`} Zur Klinik
                        </a>
                    </div>
                </div>
            </div>
            <span
                style={{
                    fontSize: 32,
                    alignItems: 'center',
                    position: 'absolute',
                    bottom: -7,
                    left: '50%',
                    color: 'white',
                    transform: 'translateX(-50%)',
                    opacity,
                }}
            >
                &#128899;
            </span>
        </foreignObject>
    )
}

export default ClinicInfo
